import letterBatches from "./letterBatches.json";
import map from "./map.json";

export default {
  ...map,
  ...letterBatches,
};
